import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { FirestoreWork } from '@jessie/commons';

@Component({
  selector: 'app-week-work-card',
  template: `
    <div
      class="rounded text-xs p-1 overflow-hidden h-full"
      [class.bg-billable-surface]="work.data.position.billable"
      [class.text-billable-fg]="work.data.position.billable"
      [class.bg-non-billable-surface]="!work.data.position.billable"
      [class.text-non-billable-fg]="!work.data.position.billable"
    >
      <p class="font-medium truncate leading-tight">{{ work.data.project.displayName }}</p>
      <p class="truncate leading-tight opacity-80">{{ work.data.position.displayName }}</p>
      <p class="leading-tight">
        @if (sessionMinutes !== null) {
          {{ (sessionMinutes / 60).toFixed(1) }}h session ·
        }
        {{ (work.data.workMinutes / 60).toFixed(1) }}h total
      </p>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WeekWorkCardComponent {
  @Input({ required: true }) work!: FirestoreWork;
  @Input() sessionMinutes: number | null = null;
}
